import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import LocalStorageServices from '../../../helpers/LocalStorageServices';
import MyToggle from '../../../components/MyToggle';
import EmptyHeight from '../../../components/EmptyHeight';

function SelectCategory({ setValue, setTempComponentState }) {
  const { categories } = useSelector((store) => store.staticData);
  const [workingWithOnlineCategories, setWorkingWithOnlineCategories] = useState(Boolean(LocalStorageServices.getIsWorkingWithOnlineCategories()));
  const filteredCategories = useMemo(() => (Array.isArray(categories) ? categories.filter((i) => Boolean(i.is_online) === workingWithOnlineCategories) : []), [categories, workingWithOnlineCategories]);

  const handleClick = (item) => {
    setValue(item);
    setTempComponentState(null);
  };

  const handleIsWorkingWithOnlineCategoriesToggle = () => {
    const newVal = !workingWithOnlineCategories;
    setWorkingWithOnlineCategories(newVal);
    LocalStorageServices.setIsWorkingWithOnlineCategories(newVal);
  };

  return (
    <div className="temp_container">
      <p className="temp_container_title">Выберите категорию</p>
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', transform: 'scale(0.8)',
      }}
      >
        <p>Онлайн категории</p>
        <MyToggle value={workingWithOnlineCategories} onClick={handleIsWorkingWithOnlineCategoriesToggle} />
      </div>
      <div className="temp_container_scroll">
        {filteredCategories.map((item) => (
          <div className="temp_container_item" key={item._id} onClick={() => handleClick(item)}>
            <p className="temp_container_item_text">{item.name}</p>
          </div>
        ))}
        <EmptyHeight height={50} />
      </div>
    </div>
  );
}

export default SelectCategory;
